import React, { useEffect, useState } from 'react';
import { Grid, TextField } from '@mui/material';
import { EventReviewProps } from '../EventReview';
import { useAllUsers } from '../../../hooks/useAllUsers';
import { Event, LevelOneApprover, User } from '../../../services/Types';
import DropDownSelectorApprover from '../../../components/DropDownSelector/DropDownSelectorApprover';
import { usePermissions } from '../../../hooks/usePermissions';
import DropDownSelectorProgramOffice from '../../../components/DropDownSelector/DropDownSelectorProgramOffice';
import { formatDateSystem } from '../../../services/Helper';
import { useEventValidation } from '../../../contexts/EventValidationContext';

export const BasicInfoReview: React.FC<EventReviewProps> = ({ eventData, handleEventChange }) => {
  const { userIsAdmin, userIsRequester, eventIsSaved } = usePermissions(eventData || {} as Event);
  const { users } = useAllUsers();
  const { isFieldEnabled } = useEventValidation();
  const [creator, setCreator] = useState<User | null>(null);
  const [levelOneApprover, setLevelOneApprover] = useState<LevelOneApprover[]>([]);


  useEffect(() => {
    setCreator(users.find(user => user.id === eventData?.creater.id) || null);
    setLevelOneApprover(users.filter(user => user.email === eventData?.levelOneApprover?.email).map(user => ({
      id: user.id,
      name: `${user.firstName} ${user.lastName}`,
      email: user.email
    })));
  }, [users, eventData]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <TextField
          label="Creator"
          value={`${creator?.firstName || ''} ${creator?.lastName || ''}`}
          disabled={true}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="Email"
          value={creator?.email || ''}
          disabled={true}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="Created At"
          value={formatDateSystem(eventData?.createdAt)}
          disabled={true}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="Updated At"
          value={formatDateSystem(eventData?.updatedAt)}
          disabled={true}
        />
      </Grid>
      <Grid item xs={6}>
        <DropDownSelectorProgramOffice
          selectedOffice={eventData?.programOffice ?? null}
          onOfficeChange={(office) => {
            const syntheticEvent = {
              target: { value: office || null }
            } as unknown as React.ChangeEvent<HTMLInputElement>;
            handleEventChange('programOffice')(syntheticEvent);
          }}
          disabled={!isFieldEnabled(!userIsAdmin &&!(userIsRequester && eventIsSaved))}
        />
      </Grid>
      <Grid item xs={6}>
        <DropDownSelectorApprover
          disabled={!isFieldEnabled(!userIsAdmin &&!(userIsRequester && eventIsSaved))}
          programOfficeId={eventData?.programOffice?.id || 0}
          approverLevel={1}
          selectedApprover={eventData?.levelOneApprover || null}
          onApproverChange={(approver) => {
            const syntheticEvent = {
              target: { value: approver || null }
            } as unknown as React.ChangeEvent<HTMLInputElement>;
            console.log("syntheticEvent", syntheticEvent)
            handleEventChange('levelOneApprover')(syntheticEvent);
          }}
        />
      </Grid>
    </Grid>
  );
}; 